import { ref, computed, watch, onMounted, reactive } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import router from '@/router'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'
import axios from '@axios'
store.dispatch('action_plan/getAll');
export default function useList() {
  const refListTable = ref(null);
  const tenantWithStorage = reactive([]);

  const toast = useToast()

  store.dispatch('tenant/getUserTenanats');

  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems']);

  const tenantFilter = ref(null);

  const tenantOptionsMap = computed(() => {
    return tenantOptions.value.reduce((map, tenant) => {
      map[tenant.value] = tenant.label; // Map tenant ID to its label
      return map;
    }, {});
  });


  if (router.currentRoute.params.id_tenant){
    tenantFilter.value = parseInt(router.currentRoute.tenant)
  }
  //Get tenants with a storage assigned
  async function fetchTenantData() {
    try {
      const response = await axios.get(window.__env.VUE_APP_FILESYSTEM_URL+'/v1/tenant');

      const tenantsData = response.data.data;

      if (Array.isArray(tenantsData)) {
        tenantsData.forEach(tenant => {
          tenantWithStorage.push({
            label: tenant.name,
            value: tenant.id,
          });
        });
      } else {
        console.error('Expected an array, but got:', tenantsData);
      }
    } catch (error) {
      console.error('Error fetching tenant data:', error);
    }
  };

  const tableColumns = [
    { key: 'actions', label: 'Actions' },

    { label: 'action_plan.documentTable.name', key: 'name', sortable: true },
    { label: 'action_plan.documentTable.description', key: 'description', sortable: true },
    { label: 'action_plan.documentTable.view', key: 'view', sortable: true },
    { label: 'action_plan.documentTable.tenant', key: 'tenantName', sortable: false },
    { label: 'action_plan.documentTable.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'action_plan.documentTable.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ]
  if (ability.can('update', 'Center') == true || ability.can('delete', 'Center') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })

  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })


  const fetchList = (ctx, callback) => {
    store.dispatch('action_plan_document/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_tenant: tenantFilter.value,
    })
      .then(response => {

      const filteredData = response.data.filter(item => item.tenant_id && tenantOptionsMap.value[item.tenant_id]);

      const formattedData = filteredData.map(item => ({
        ...item,
        tenantName: tenantOptionsMap.value[item.tenant_id] || 'Unknown Tenant',
      }));

      callback(formattedData);

      totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_tenant: tenantFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    tenantFilter.value = null;
    buildFilters();
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,

    tenantOptions,
    tenantFilter,

    refetchData,

    filtersCount,
    buildFilters,
    clearSearchFilters,
    tenantWithStorage,
    fetchTenantData,
  }
}
